export default function TikTokLogo(props: React.ComponentProps<"svg">) {
    return (
        <svg
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7" clipPath="url(#clip0_1173_3319)">
                <path
                    d="M11.6306 0C11.5895 0.251717 11.6275 0.548291 11.6716 0.802789C11.9803 2.58464 13.5738 4.01802 15.3881 4.29142C15.5832 4.3209 15.8082 4.35278 16 4.31534V7.3897C14.4373 7.34095 12.8941 6.92593 11.6308 6.01915L11.6304 12.4177C11.5179 15.9025 8.31606 18.5453 4.75001 17.9034C0.410951 17.1223 -1.47551 12.0559 1.31543 8.71427C2.58713 7.19155 4.58587 6.42527 6.59639 6.66735V9.81586C6.41781 9.77267 6.23886 9.7241 6.05477 9.70483C3.60027 9.44829 2.14012 12.3493 3.81286 14.1128C5.50175 15.8932 8.5066 14.6259 8.45892 12.252L8.45816 0H11.6308L11.6306 0Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_1173_3319">
                    <rect width="16" height="18" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}
